// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"85":"b90f7561","141":"df381d11","169":"8e28b3b8","720":"0dc93e6d","813":"3c7234a8","838":"e5127db7"}[chunkId] + ".css";
};